exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-plan .admin-table td>div[data-v-d6aaa1ee]{-webkit-line-clamp:unset}", ""]);

// exports
